import {
  ApplicationRef,
  ComponentRef,
  EnvironmentInjector,
  Injectable,
  createComponent,
  signal,
} from '@angular/core';
import { Toast } from '../../components/ui/toast/toast';

export interface ToastModel {
  text: string;
  classname: string;
  delay: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private containerRef?: ComponentRef<Toast>;

  // reactive list of toasts
  toasts = signal<ToastModel[]>([]);

  toastClass = 'bg-{color}-subtle border border-{color} border-opacity-75';

  constructor(
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector,
  ) {}

  /** Ensure the toast container is created and attached */
  private ensureContainer() {
    if (!this.containerRef) {
      this.containerRef = createComponent(Toast, {
        environmentInjector: this.injector,
      });
      this.appRef.attachView(this.containerRef.hostView);
      document.body.appendChild(this.containerRef.location.nativeElement);
    }
  }

  private show(text: string, classname: string, delay = 5000) {
    this.ensureContainer();
    this.toasts.update((current) => [...current, { text, classname, delay }]);
  }

  showSuccess(message: string) {
    const className = this.toastClass.replaceAll('{color}', 'success');
    this.show(message, className);
  }

  showError(message: string) {
    const className = this.toastClass.replaceAll('{color}', 'danger');
    this.show(message, className);
  }

  showWarning(message: string) {
    const className = this.toastClass.replaceAll('{color}', 'warning');
    this.show(message, className);
  }

  showInfo(message: string) {
    const className = this.toastClass.replaceAll('{color}', 'info');
    this.show(message, className);
  }

  /** Remove a toast */
  remove(toast: ToastModel) {
    this.toasts.update((current) => current.filter((t) => t !== toast));
  }
}
